import { useMutation } from '@tanstack/react-query'
import { format } from 'date-fns'

import { CartStoreSlices } from '@/stores/cart-store/slices/types'

import { reserveOrder } from '../api/reserveOrder'
import { ReservationParams, ReservationResponse } from '../types'

export const mapStoreToNewReservation = (cart: CartStoreSlices): ReservationParams | undefined => {
	const hotelCode = cart.location?.hotelCode
	const arrivalDate = cart.travelPeriod.startDate
	const departureDate = cart.travelPeriod.endDate

	if (!hotelCode || !arrivalDate || !departureDate) return

	return {
		hotelCode,
		arrivalDate: format(arrivalDate, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
		departureDate: format(departureDate, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
		promotionCode: cart.promotion.code,
		roomRequests: cart.roomSelection.selectedRooms.map((sr) => {
			const config = cart.roomConfigurations.find((config) => config.id === sr.roomConfigId)

			return {
				adults: config?.adults ?? 1,
				childrenAges: config?.children,
				roomTypeCode: sr.room.roomTypeCode,
				ratePlanCode: sr.room.rate.ratePlanCode,
				services: sr.room.services.map((service) => ({
					serviceCode: service.serviceCode,
					quantity: service.quantity,
				})),
			}
		}),
	}
}

type useReserveOrderParams = {
	onSuccess: (response: ReservationResponse) => void
}

export const useReserveOrder = ({ onSuccess }: useReserveOrderParams) => {
	return useMutation({
		mutationFn: (params: ReservationParams) => {
			return reserveOrder(params)
		},
		onSuccess,
	})
}
